import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../services/AuthService";
import LoadingComponent from "assets/theme/functions/loadingAnimation";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(AuthService.getCurrentUser());
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const initAuth = async () => {
      if (AuthService.isAuthenticated()) {
        try {
          const currentUser = AuthService.getCurrentUser();
          setToken(AuthService.getToken());
          setUser(currentUser);
        } catch (error) {
          console.error("Erro ao buscar usuário atual:", error);
          AuthService.logout();
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const response = await AuthService.login(email, password);
      setToken(response);
      
      const currentUser = AuthService.getCurrentUser();
      setUser(currentUser);
      if (currentUser?.Role?.Description.toLowerCase() === "admin") {
        navigate("/perfil");
      }
      else {
        navigate("/ofertas");
      }
      // if (!state.type) {
      //   navigate("/ofertas");
      // }
      // else if (state.type === 'Q') {
      //   navigate(`/ofertas/${state.guid}`, { state: { pw: state.pw } });
      // }
      // else if (state.type === 'O') {
      //   navigate(`/pedidos/${state.guid}`, { state: { pw: state.pw } });
      // }
      
    } catch (error) {
      console.error("Erro no login:", error);
      throw error;
    }
  };

  const logout = () => {
    AuthService.logout();
    setUser(null);
    navigate("/login");
  };

  const updateUser = async () => {
    try {
      const updatedUser = AuthService.getCurrentUser();
      setUser(updatedUser);
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
    }
  }

  const redirect = () => {
    if (!token) {
      navigate("/login");
    }
  };

  const isAuthenticated = () => AuthService.isAuthenticated();



  return (
    <AuthContext.Provider 
      value={{ 
        user, 
        token,
        login, 
        logout,
        redirect,
        updateUser, 
        isAuthenticated 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);